<template>
	<div class="flex bg4 bb1 bc7--l3 submenu-wrapper mb4">
		<div class="flex wrap xs-12 md-pl8 md-pr8 pr4 pl4">
			<!-- Headline -->
			<h2 class="xs-12 md-3 fs7 lh125 fw7 c1 pt3 pb3">
				<slot></slot>
			</h2>

			<!-- Menu -->
			<div class="flex xs-12 md-9">
				<j-box-horizontal-scroll
					class="flex xs-12 xs-middle xs-left md-right md-mt0"
				>
					<router-link
						v-for="(item, i) in tabs"
						:key="i"
						:to="item.to"
						class="submenu-link ml0 mr8 md-mr0 md-ml8 pt4 pb4 pr2 pl2"
						exact-active-class="submenu-link--active"
					>
						{{ item.name }}
					</router-link>
				</j-box-horizontal-scroll>
			</div>
		</div>
	</div>
</template>

<script>
import JBoxHorizontalScroll from "@/components/JBoxHorizontalScroll/"

export default {
	components: { JBoxHorizontalScroll },
	props: {
		/**
		 * Array should have objects like so:
		 * @param [{name:"Logs", to: {name: "Logs" } }]
		 */
		tabs: { type: Array, default: () => [] }
	}
}
</script>

<style scoped>
@import "../../../assets/css/tokens.css";

.submenu-link {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	color: var(--color7-dark-1);
	font-weight: var(--fontWeight400);
	font-size: var(--fontSize3);
	line-height: var(--lineHeight125);
	font-weight: var(--fontWeight7);
	text-decoration: none;
	text-transform: uppercase;
	white-space: nowrap;
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	transition: all 300ms ease-out;
	cursor: pointer;
}

.submenu-link:hover {
	color: var(--color1);
}

.submenu-link--active {
	color: var(--color1);
}

.submenu-link::before {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 3px;
	background-color: var(--color2);
	transform: translateY(10px);
	opacity: 0;
	transition: all 300ms ease-out;
}

.submenu-link--active.submenu-link::before {
	transform: translateY(2px);
	opacity: 1;
}

.submenu-wrapper {
	background-color: var(--color5);
}

@media (--md) {
	.submenu-wrapper {
		position: sticky;
		top: 0;
		z-index: 99;
		background-color: var(--color4);
	}
}
</style>
